import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dEnvironment from "../Restaumatic.Environment/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Restaumatic$dOldForm from "../Restaumatic.OldForm/index.js";
import * as Restaumatic$dOrder$dTypes from "../Restaumatic.Order.Types/index.js";
import * as Restaumatic$dPrelude$dSpecular from "../Restaumatic.Prelude.Specular/index.js";
import * as Restaumatic$dSite$dComponents$dDeliveryAddress from "../Restaumatic.Site.Components.DeliveryAddress/index.js";
import * as Restaumatic$dSite$dComponents$dQrWaiter from "../Restaumatic.Site.Components.QrWaiter/index.js";
import * as Restaumatic$dSite$dTranslations$dKeys from "../Restaumatic.Site.Translations.Keys/index.js";
import * as Restaumatic$dStorage from "../Restaumatic.Storage/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dExtra$dSwitch from "../Specular.Extra.Switch/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Utils$dJS$dTooltip from "../Utils.JS.Tooltip/index.js";
const fromFulfillmentMethodType = v => {
  if (v.tag === "Delivery") { return Restaumatic$dOrder$dTypes.$DeliveryMethod$p("DeliveryMethodShipment", Type$dProxy.Proxy); }
  if (v.tag === "Takeaway") { return Restaumatic$dOrder$dTypes.DeliveryMethodPickup; }
  if (v.tag === "DineIn") { return Restaumatic$dOrder$dTypes.$DeliveryMethod$p("DeliveryMethodDineIn", Type$dProxy.Proxy); }
  if (v.tag === "NoContactDelivery") { return Restaumatic$dOrder$dTypes.$DeliveryMethod$p("DeliveryMethodNoContactDelivery", Type$dProxy.Proxy); }
  $runtime.fail();
};
const deliveryMethodSelect = initial => options => Specular$dDom$dElement.el_("div")(Restaumatic$dOldForm.radioGroupFieldInitiallyEmpty(Restaumatic$dOrder$dTypes.eqDeliveryMethod(Data$dEq.eqProxy)(Data$dEq.eqProxy))({
  label: Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.order.delivery_method), {}),
  initial,
  options: Data$dArray.filter(v => Data$dFoldable.foldableArray.foldMap({mempty: false, Semigroup0: () => ({append: v$1 => v1 => v$1 || v1})})(Restaumatic$dOrder$dTypes.eqDeliveryMethod(Data$dEq.eqProxy)(Data$dEq.eqProxy).eq(v))(options))([
    Restaumatic$dOrder$dTypes.$DeliveryMethod$p("DeliveryMethodNoContactDelivery", Type$dProxy.Proxy),
    Restaumatic$dOrder$dTypes.$DeliveryMethod$p("DeliveryMethodShipment", Type$dProxy.Proxy),
    Restaumatic$dOrder$dTypes.DeliveryMethodPickup,
    Restaumatic$dOrder$dTypes.$DeliveryMethod$p("DeliveryMethodDineIn", Type$dProxy.Proxy)
  ]),
  required: true,
  testId: v => {
    if (v.tag === "DeliveryMethodPickup") { return "FulfillmentMethod/Pickup"; }
    if (v.tag === "DeliveryMethodShipment") { return "FulfillmentMethod/Shipment"; }
    if (v.tag === "DeliveryMethodNoContactDelivery") { return "FulfillmentMethod/NoContactDelivery"; }
    if (v.tag === "DeliveryMethodDineIn") { return "FulfillmentMethod/DineIn"; }
    $runtime.fail();
  },
  display: v => _selected => {
    if (v.tag === "DeliveryMethodPickup") {
      return Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery_method.pickup),
        {}
      ));
    }
    if (v.tag === "DeliveryMethodShipment") {
      return Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery_method.shipment),
        {}
      ));
    }
    if (v.tag === "DeliveryMethodNoContactDelivery") {
      return Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery_method.no_contact_delivery_choice),
        {}
      ) + " "))(() => Specular$dInternal$dRIO.bindImpl(Restaumatic$dEnvironment.isMobileApp)(isMobileApp$p => Specular$dInternal$dRIO.bindImpl(Specular$dDom$dElement.el("span")([
        Specular$dDom$dElement.class_("js-ps-tooltip"),
        Specular$dDom$dElement.attr("title")(Restaumatic$dI18n._translate(
          Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery_method.no_contact_delivery_tooltip),
          {}
        )),
        Specular$dDom$dElement.attr("tabindex")("0"),
        (() => {
          if (!isMobileApp$p) { return Specular$dDom$dElement.monoidProp.mempty; }
          if (isMobileApp$p) { return Specular$dDom$dElement.attr("data-bs-placement")("bottom"); }
          $runtime.fail();
        })()
      ])(Specular$dDom$dElement.el("span")([Specular$dDom$dElement.class_("icon-help-circled")])(Restaumatic$dPrelude$dSpecular.wempty)))(() => Utils$dJS$dTooltip.initPSTooltip(".js-ps-tooltip"))));
    }
    if (v.tag === "DeliveryMethodDineIn") {
      return Specular$dDom$dElement.text(Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dSite$dTranslations$dKeys.t.delivery_method.dine_in),
        {}
      ));
    }
    $runtime.fail();
  }
})("")(""));
const deliveryMethodSelectWithStorage = options => Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.bindImpl(Specular$dInternal$dRIO.mapImpl(v => v.storage)(Specular$dDom$dBuilder.monadAskBuilder.ask))(storage => storage._1(Restaumatic$dOrder$dTypes.decodeDeliveryMethodType)("deliveryMethod")))(storedMethod => Specular$dInternal$dRIO.bindImpl(deliveryMethodSelect(storedMethod)(options))(value => Specular$dInternal$dRIO.bindImpl(Restaumatic$dStorage.storeValue({
  encode: v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") {
      if (v2._1.tag === "DeliveryMethodPickup") { return "pickup"; }
      if (v2._1.tag === "DeliveryMethodShipment") { return "shipment"; }
      if (v2._1.tag === "DeliveryMethodDineIn") { return "dine_in"; }
      if (v2._1.tag === "DeliveryMethodNoContactDelivery") { return "no_contact_delivery"; }
      $runtime.fail();
    }
    $runtime.fail();
  }
})(Specular$dDom$dBuilder.monadReaderBuilder)({MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO, MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder})("deliveryMethod")(value))(() => Specular$dInternal$dRIO.pureImpl(value))));
const deliveryMethodWidget = config => {
  const customizedDeliveryAddressWidget = Restaumatic$dSite$dComponents$dDeliveryAddress.autolocatingDeliveryAddressWidget({
    withAptInfo: config.withAptInfo,
    withEmptyMessage: !config.withAptInfo,
    country: config.country,
    accountId: config.accountId,
    restaurantId: Data$dMaybe.$Maybe("Just", config.restaurantId),
    visible: (() => {
      const n = Specular$dInternal$dIncremental.constant(true);
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })()
  });
  return Specular$dInternal$dRIO.bindImpl(Restaumatic$dSite$dComponents$dQrWaiter.readDineInLocation(Specular$dDom$dBuilder.monadReaderBuilder)(Specular$dInternal$dRIO.monadEffectRIO))(dineInLocation => {
    if (
      (() => {
        if (dineInLocation.tag === "Nothing") { return false; }
        if (dineInLocation.tag === "Just") { return true; }
        $runtime.fail();
      })()
    ) {
      return Specular$dInternal$dRIO.pureImpl((() => {
        const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.$Maybe(
          "Just",
          Restaumatic$dOrder$dTypes.$DeliveryMethod$p("DeliveryMethodDineIn", Data$dMaybe.$Maybe("Just", {location: dineInLocation}))
        ));
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })());
    }
    return Specular$dInternal$dRIO.bindImpl(deliveryMethodSelectWithStorage(Data$dFunctor.arrayMap(fromFulfillmentMethodType)(config.fulfillmentMethods)))(v => Specular$dExtra$dSwitch.dynamicSwitch(Specular$dExtra$dSwitch.switchDynamic)(Specular$dDom$dBuilder.monadReplaceBuilder)({
      MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
      MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
    })(Specular$dFRP$dBase.functorDynamic.map(v1 => {
      if (v1.tag === "Just") {
        if (v1._1.tag === "DeliveryMethodPickup") {
          return Specular$dInternal$dRIO.pureImpl((() => {
            const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.$Maybe("Just", Restaumatic$dOrder$dTypes.DeliveryMethodPickup));
            Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
            return n;
          })());
        }
        if (v1._1.tag === "DeliveryMethodShipment") {
          return Specular$dInternal$dRIO.mapImpl(x => Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dOrder$dTypes.DeliveryMethodShipment)(x.address)))(customizedDeliveryAddressWidget);
        }
        if (v1._1.tag === "DeliveryMethodNoContactDelivery") {
          return Specular$dInternal$dRIO.mapImpl(x => Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dOrder$dTypes.DeliveryMethodNoContactDelivery)(x.address)))(customizedDeliveryAddressWidget);
        }
        if (v1._1.tag === "DeliveryMethodDineIn") {
          return Specular$dInternal$dRIO.pureImpl((() => {
            const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.$Maybe(
              "Just",
              Restaumatic$dOrder$dTypes.$DeliveryMethod$p("DeliveryMethodDineIn", Data$dMaybe.$Maybe("Just", {location: Data$dMaybe.Nothing}))
            ));
            Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
            return n;
          })());
        }
        $runtime.fail();
      }
      if (v1.tag === "Nothing") {
        return Specular$dInternal$dRIO.pureImpl((() => {
          const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.Nothing);
          Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
          return n;
        })());
      }
      $runtime.fail();
    })(v)));
  });
};
export {deliveryMethodSelect, deliveryMethodSelectWithStorage, deliveryMethodWidget, fromFulfillmentMethodType};
